const locales = {
    en: require("./en.js").default,
    uk: require("./uk.js").default,
    ru: require("./ru.js").default
};

export default locales;
